var _excluded = ["title", "stroke", "dir"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgStarHalfFilled = function SvgStarHalfFilled(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Half Filled Star' : _ref$title,
    stroke = _ref.stroke,
    dir = _ref.dir,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 46 44"
  }, dir === 'rtl' ? {
    transform: 'scale(-1, 1)'
  } : {}), /*#__PURE__*/React.createElement("path", {
    stroke: stroke,
    strokeWidth: 3,
    d: "M23 0l7.053 14.292 15.772 2.292-11.412 11.124 2.694 15.708L23 36 8.893 43.416l2.694-15.708L.175 16.584l15.772-2.292L23 0zm0 4v29.85L34.743 40 32.5 26.975l9.5-9.224-13.129-1.9L23 4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "var(--cds-color-white-0, #fff)",
    strokeWidth: 3,
    stroke: stroke,
    points: "22.8253564 36 22.8253564 2.34479103e-13 29.8787794 14.2917961 45.6507128 16.5835921 34.2380346 27.7082039 36.9322024 43.4164079"
  }));
};
SvgStarHalfFilled = pure(SvgStarHalfFilled);
SvgStarHalfFilled.displayName = 'SvgStarHalfFilled';
export default SvgStarHalfFilled;